document.addEventListener('DOMContentLoaded',function(){
  var home=document.querySelector('.lv-homepage');
  if(!home)return;
  var section=home.querySelector('.lv-paper.lv-section');
  if(!section)return;

  var options=[
    {key:'bls',title:'AHA BLS Provider',detail:'Healthcare-provider BLS certification',group:'Official course'},
    {key:'bls-skills',title:'AHA BLS Skills Session',detail:'Hands-on skills session for eligible HeartCode BLS learners',group:'Official course'},
    {key:'cpr-aed',title:'AHA Heartsaver CPR AED',detail:'CPR and AED training for workplaces and community groups',group:'Official course'},
    {key:'first-aid',title:'AHA Heartsaver First Aid',detail:'First aid training without CPR/AED',group:'Official course'},
    {key:'first-aid-cpr-aed',title:'AHA Heartsaver First Aid CPR AED',detail:'First aid, CPR, and AED training in one course',group:'Official course'},
    {key:'pediatric',title:'AHA Heartsaver Pediatric First Aid CPR AED',detail:'Pediatric first aid, CPR, and AED training for caregivers and organizations',group:'Official course'},
    {key:'bbp',title:'AHA Heartsaver Bloodborne Pathogens',detail:'Bloodborne-pathogens education for workplace exposure awareness',group:'Official course'},
    {key:'stb',title:'ACS STOP THE BLEED®',detail:'Official hands-on bleeding-control training',group:'Official course'},
    {key:'severe-bleeding',title:'LV Severe Bleeding & Tourniquet Skills',detail:'Additional practice with pressure, wound packing, and tourniquets',group:'LV skills'},
    {key:'naloxone',title:'LV Opioid Overdose & Naloxone Response',detail:'Recognize a suspected opioid emergency and practice naloxone response',group:'LV skills'},
    {key:'recognition',title:'LV Emergency Recognition & Initial Assessment',detail:'Practice recognizing a medical emergency and beginning an organized response',group:'LV skills'},
    {key:'lab',title:'LV Lab medical simulation',detail:'Scenario-based practice using realistic medical problems',group:'LV simulation'}
  ];

  var packages=[
    {keys:['bls','pediatric'],title:'Adult, Child & Infant Coverage',handle:'aha-complete-adult-pediatric-response-package',price:'$155',note:'Combines AHA BLS Provider with pediatric first aid/CPR/AED coverage. Each AHA course keeps its own requirements and completion documentation.'},
    {keys:['first-aid-cpr-aed','severe-bleeding'],title:'Workplace Essentials',handle:'workplace-essentials-package-cpr-aed-first-aid-bleeding-response',price:'$165',note:'Combines AHA Heartsaver First Aid CPR AED with separate LV severe-bleeding and tourniquet skills practice.'},
    {keys:['first-aid-cpr-aed','severe-bleeding','naloxone','recognition'],title:'Complete Workplace Response',handle:'complete-workplace-response-package-first-aid-cpr-aed-bleeding-naloxone',price:'$279',note:'Combines AHA First Aid CPR AED with LV severe-bleeding, opioid-overdose response, and emergency-recognition training.'},
    {keys:['bls','severe-bleeding','naloxone','recognition'],title:'Provider Plus',handle:'provider-plus-package-bls-advanced-response-skills',price:'$269',note:'Covers these selections and adds coordinated scenario-response practice. This does not mean the full standalone LV Lab product is included.'},
    {keys:['pediatric','severe-bleeding','recognition'],title:'Pediatric & Caregiver Complete',handle:'pediatric-caregiver-complete-package-pediatric-first-aid-cpr-aed-bleeding-response',price:'$165',note:'Combines pediatric first aid/CPR/AED training with LV severe-bleeding and emergency-recognition skills.'},
    {keys:['bls','pediatric','severe-bleeding','naloxone','recognition','lab'],title:'Provider Complete',handle:'provider-complete-package-bls-first-aid-pediatric-lv-response-skills',price:'$329',note:'Combines BLS, pediatric training, LV response skills, and medical simulation in the existing Provider Complete package.'}
  ];

  function escapeHtml(value){return String(value).replace(/[&<>\"]/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;'}[ch];});}
  function sameSet(a,b){if(a.length!==b.length)return false;var aa=a.slice().sort();var bb=b.slice().sort();return aa.every(function(v,i){return v===bb[i];});}

  var shell=document.createElement('div');
  shell.className='lv-shell lv-selector';
  shell.innerHTML='<div class="lv-selector-head"><div class="lv-kicker">Build your training</div><h2>Select the classes your group needs.</h2><p>Choose one or more current courses or skills modules. We will show what your plan includes and identify an existing Limen Vitalis package when your selections match one.</p></div>';

  var fieldset=document.createElement('fieldset');
  fieldset.className='lv-selector-grid';
  fieldset.setAttribute('aria-label','Select training options');

  options.forEach(function(item){
    var label=document.createElement('label');
    label.className='lv-selector-item';
    label.innerHTML='<input type="checkbox" data-key="'+escapeHtml(item.key)+'" value="'+escapeHtml(item.title)+'"><span><span class="lv-selector-type">'+escapeHtml(item.group)+'</span><strong>'+escapeHtml(item.title)+'</strong><small>'+escapeHtml(item.detail)+'</small></span>';
    fieldset.appendChild(label);
  });

  var summary=document.createElement('section');
  summary.className='lv-bundle-summary';
  summary.hidden=true;
  summary.setAttribute('aria-live','polite');
  summary.innerHTML='<div class="lv-bundle-summary-head"><div><div class="lv-kicker">Your training plan</div><h3 class="lv-bundle-count"></h3></div><button type="button" class="lv-bundle-clear">Clear</button></div><div class="lv-bundle-groups"></div><div class="lv-package-match" hidden></div>';

  var actions=document.createElement('div');
  actions.className='lv-selector-actions';
  actions.innerHTML='<button type="button" class="lv-btn lv-btn-primary lv-selector-continue" disabled>Continue with this plan</button><a class="lv-selector-unsure" href="/pages/request-training-quote">Not sure? Tell us your goal →</a>';

  var note=document.createElement('p');
  note.className='lv-selector-note';
  note.textContent='This builds a training request; it does not reserve a date. Course eligibility, instructor availability, location, and group details are confirmed during review.';

  shell.appendChild(fieldset);
  shell.appendChild(summary);
  shell.appendChild(actions);
  shell.appendChild(note);
  section.innerHTML='';
  section.appendChild(shell);

  var checks=Array.prototype.slice.call(fieldset.querySelectorAll('input[type="checkbox"]'));
  var button=actions.querySelector('.lv-selector-continue');
  var clear=summary.querySelector('.lv-bundle-clear');
  var groups=summary.querySelector('.lv-bundle-groups');
  var matchBox=summary.querySelector('.lv-package-match');
  var count=summary.querySelector('.lv-bundle-count');

  function selectedItems(){
    return checks.filter(function(c){return c.checked;}).map(function(c){var key=c.getAttribute('data-key');return options.find(function(o){return o.key===key;});}).filter(Boolean);
  }
  function exactPackage(keys){return packages.find(function(p){return sameSet(p.keys,keys);})||null;}
  function renderList(title,items){if(!items.length)return '';return '<div class="lv-bundle-group"><span>'+escapeHtml(title)+'</span><ul>'+items.map(function(i){return '<li>'+escapeHtml(i.title)+'</li>';}).join('')+'</ul></div>';}
  function update(){
    var items=selectedItems();
    var keys=items.map(function(i){return i.key;});
    button.disabled=!items.length;
    summary.hidden=!items.length;
    checks.forEach(function(c){c.closest('.lv-selector-item').classList.toggle('is-selected',c.checked);});
    if(!items.length){matchBox.hidden=true;matchBox.innerHTML='';delete matchBox.dataset.matchKind;groups.innerHTML='';count.textContent='';return;}

    count.textContent=items.length+(items.length===1?' selection':' selections');
    var official=items.filter(function(i){return i.group==='Official course';});
    var lv=items.filter(function(i){return i.group!=='Official course';});
    groups.innerHTML=renderList('Official courses / credentials',official)+renderList('Additional LV skills / simulation',lv);

    var pkg=exactPackage(keys);
    if(pkg){
      matchBox.dataset.matchKind='exact';
      matchBox.hidden=false;
      matchBox.innerHTML='<div class="lv-package-match-label">Package match</div><div class="lv-package-match-grid"><div><h4>'+escapeHtml(pkg.title)+'</h4><p>'+escapeHtml(pkg.note)+'</p></div><div class="lv-package-match-action"><strong>'+escapeHtml(pkg.price)+'</strong><a class="lv-btn lv-btn-primary" href="/products/'+escapeHtml(pkg.handle)+'">View this package</a></div></div>';
    }else{
      matchBox.hidden=true;
      matchBox.innerHTML='';
      delete matchBox.dataset.matchKind;
    }
    document.dispatchEvent(new CustomEvent('lv:training-selection-changed',{detail:{keys:keys}}));
  }

  checks.forEach(function(c){c.addEventListener('change',update);});
  clear.addEventListener('click',function(){checks.forEach(function(c){c.checked=false;});update();});
  button.addEventListener('click',function(){
    var items=selectedItems();
    if(!items.length)return;
    var titles=items.map(function(i){return i.title;});
    var pkg=exactPackage(items.map(function(i){return i.key;}));
    try{sessionStorage.setItem('lvSelectedTraining',JSON.stringify(titles));if(pkg)sessionStorage.setItem('lvMatchedPackage',pkg.title);else sessionStorage.removeItem('lvMatchedPackage');}catch(e){}
    var url='/pages/request-training-quote?training='+encodeURIComponent(titles.join(','));
    if(pkg)url+='&package='+encodeURIComponent(pkg.title);
    window.location.href=url;
  });
  update();
});
